/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */
/** The visual style variant for buttons. */
export var ButtonVariant = {
    MINIMAL: "minimal",
    OUTLINED: "outlined",
    SOLID: "solid",
};
//# sourceMappingURL=buttonVariant.js.map